import { inject, Injectable } from '@angular/core';
import { ImpersonationRedeemConfirmDialogComponent } from '@rd/core/components/impersonation-redeem-confirm-dialog/impersonation-redeem-confirm-dialog.component';
import { DialogService } from '@rd/popup/services/dialog/dialog.service';
import { WontFixType } from 'global-types';
import { AuthFacade } from '../../auth/store/facades/auth.facade';
import { EnvService } from '../env/env.service';

export function injectCheckImpersonation<
  Function extends (...args: WontFixType[]) => void,
>(callback: Function): (...args: Parameters<Function>) => void {
  const impersonationService = inject(ImpersonationService);

  return (...args: Parameters<Function>) => {
    impersonationService.guardImpersonateRedeemAction(() => callback(...args));
  };
}

@Injectable({
  providedIn: 'root',
})
export class ImpersonationService {
  isImpersonated = false;
  isRequiredConfirmation = false;
  impersonatedUsername: string;

  constructor(
    private authFacade: AuthFacade,
    private dialogService: DialogService,
    private envService: EnvService,
  ) {
    this.authFacade.user$.subscribe((user) => {
      this.isImpersonated = Boolean(user?.act);
      this.isRequiredConfirmation =
        this.isImpersonated && this.envService.isProduction;
      this.impersonatedUsername = `${user?.firstName ?? ''} ${
        user?.lastName ?? ''
      }`;
    });
  }

  guardImpersonateRedeemAction(onConfirmAction: () => void): void {
    if (this.isRequiredConfirmation) {
      this.dialogService.open(ImpersonationRedeemConfirmDialogComponent, {
        data: {
          userName: this.impersonatedUsername,
          confirmAction: onConfirmAction,
        },
        id: 'rd-impersonation-redeem-confirm-dialog',
        screenMode: 'center-md',
      });
    } else {
      onConfirmAction();
    }
  }
}
